import type { ReactNode } from 'react';
import { fieldBadgeClass, type FieldTone } from '../utils';

type Props = {
    label: string;
    value: ReactNode;
    tone?: FieldTone;
    href?: string;
    className?: string;
    colSpan?: number;
};

export default function DataField({ label, value, tone = 'gray', href, className, colSpan }: Props) {
    const empty = value === null || value === undefined || value === '';
    const display = empty ? '—' : value;
    const badge = (
        <span className={fieldBadgeClass(tone)}>
            {typeof display === 'string' ? <span className="truncate">{display}</span> : display}
        </span>
    );

    return (
        <div className={className} style={colSpan ? { gridColumn: `span ${colSpan}` } : undefined}>
            <p className="mb-1 text-xs font-medium text-gray-500 dark:text-zinc-400">{label}</p>
            {href && !empty ? (
                <a href={href} className={`${fieldBadgeClass(tone)} hover:opacity-90`}>
                    {display}
                </a>
            ) : (
                badge
            )}
        </div>
    );
}
